import {
  ImageField,
  StringField,
  FooterSection,
  FooterSectionFields,
  FooterLinkFields,
  LinkField,
} from '../../../types/types'
import { FooterFields, FooterProps } from '../types/Footer.types'
import mock from '../../../mocks/Footer/Footer.mock'

export class FooterModel {
  private readonly fields?: FooterFields
  constructor(props: FooterProps) {
    this.fields = props.fields;
  }

  private filterSectionByType(list: FooterSection[], type: string) {
    return list.filter(
      (item) => item.fields?.sectionType?.fields?.Key?.value === type
    )
  }

  get footerSections(): FooterSection[] {
    return this.filterSectionByType(
      this.fields?.footerSections ?? mock.fields.footerSections,
      'groupSectionType'
    )
  }

  get navigationSection(): FooterLinkFields | undefined {
    return this.filterSectionByType(
      this.fields?.footerSections ?? mock.fields.footerSections,
      'navigationSectionType'
    )?.[0]?.fields?.footerLinks?.[0]?.fields
  }

  get actionSection(): FooterSectionFields | undefined {
    return this.filterSectionByType(
      this.fields?.footerSections ?? mock.fields.footerSections,
      'actionSectionType'
    )?.[0]?.fields
  }

  get socialMediaLinks(): FooterLinkFields | undefined {
    return this.filterSectionByType(
      this.fields?.footerSections ?? mock.fields.footerSections,
      'socialMediaSectionType'
    )?.[0]?.fields?.footerLinks?.[0]?.fields
  }

  get copyrightText(): StringField {
    return this.fields?.copyrightText ?? mock.fields.copyrightText
  }

  get image(): ImageField {
    return this.fields?.image ?? mock.fields.image
  }
  get mobileImage(): ImageField {
    return this.fields?.mobileImage ?? mock.fields.image
  }
  get allowFallbackForMobile(): boolean {
    return !!this.fields?.AllowFallbackForMobile.value
  }
  get backToTopText(): StringField {
    return this.fields?.backToTopText ?? mock.fields.backToTopText
  }
  get logoLink(): LinkField | undefined {
    return this.fields?.logoLink
  }
  get slogan(): StringField | undefined {
    return this.fields?.slogan
  }
}
